import { Loader2Icon } from "lucide-react";

import { cn } from "@lib/utils/utils";

type SpinnerSize = "xs" | "sm" | "md" | "lg";

interface SpinnerProps extends Omit<React.ComponentProps<"svg">, "size"> {
  size?: SpinnerSize;
}

const sizeClasses: Record<SpinnerSize, string> = {
  xs: "size-3",
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
};

function Spinner({ className, size = "sm", ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("text-muted-foreground animate-spin", sizeClasses[size], className)}
      {...props}
    />
  );
}

export { Spinner };
export type { SpinnerProps, SpinnerSize };
